import { List } from "immutable";
import { DataListActions } from "../actions.types";
import { commonListReducers } from "../reducer";

export function commonDatalistReducerFactory(rootProp, initialState) {
    return function commonDatalistReducer(state = initialState, action) {
        state = commonListReducers(state, action, initialState, rootProp);
        switch (action.type) {
            case `${rootProp}::${DataListActions.UPDATE_COLUMN_SORT_STATE}`:
                let newColumns = List<any>([]);
                state.getIn([action.stateProp, "listData", "columns"]).forEach((col, i) => {
                    if (i === action.payload) {
                        col = handleSelectedColumn(col);
                    } else {
                        col = handleNotSelectedColumn(col);
                    }
                    newColumns = newColumns.push(col);
                });
                return state.setIn([action.stateProp, "listData", "columns"], newColumns);

            case `${rootProp}::${DataListActions.ROW_SELECTED}`:
                state = state.setIn([action.stateProp, "listData", "selectedId"], action.payload);
                return state;

            default:
                return state;
        }
    };
};

export function handleSelectedColumn(col) {
    if (col.get("isSorted") && col.get("sortDirection") === 1) {
        col = col.set("sortDirection", -1);
    } else if (col.get("isSorted") && col.get("sortDirection") === -1) {
        col = col.set("isSorted", false);
        col = col.delete("sortDirection");
    } else {
        col = col.merge({ isSorted: true, sortDirection: 1 });
    }
    return col;
}

export function handleNotSelectedColumn(col) {
    col = col.set("isSorted", false);
    col = col.delete("sortDirection");
    return col;
}
